import React, { Component } from "react";
import PropTypes from "prop-types";
import FilterContainer from "../containers/FilterContainer";

class Z4 extends Component {
  constructor(props) {
    super(props);
  }

  renderLabel(label) {
    return <div style={{ ...styles.item }}>{label}</div>;
  }

  renderSpace() {
    return <div style={{ ...styles.emptyItem, ...styles.item }} />;
  }

  renderFilter(filter = {}, kpi) {
    return (
      <div className="p-stats-filters-item">
        {filter.title && this.renderLabel(filter.title)}
        <FilterContainer filter={filter} kpi={kpi} />
      </div>
    );
  }

  renderFilters() {
    let { filters, kpi, filtersData } = this.props;
    const elts = [];

    filters.map(filter => {
      if (filter && typeof filter === "object") {
        if (!filter.hasOwnProperty("display") || filter.display(kpi, filtersData)) {
          elts.push(this.renderFilter(filter, kpi));
        }
      } else if (filter === null) {
        elts.push(this.renderSpace());
      } else if (typeof filter === "string") {
        elts.push(this.renderLabel(filter));
      }
    });

    return elts;
  }

  render() {
    return <div className="p-stats-filters-container p-brd-bot p-pdg-bot-s p-mrg-bot-s">{this.renderFilters()}</div>;
  }
}

Z4.propTypes = {
  filters: PropTypes.array.isRequired
};

const styles = {
  contentFilters: {
    paddingTop: 5,
    paddingBottom: 5,
    marginBottom: 30
  },
  contentBorderBottom: {
    paddingBottom: 10,
    marginBottom: 10,
    borderBottom: "2px solid orange"
  },
  filtersContainer: {
    paddingLeft: 5,
    paddingRight: 5
  },
  item: {
    fontWeight:"bold",
    marginTop: 15,
    marginBottom: 5,
  },
  emptyItem: {
    height: 20
  }
};

export default Z4;



// WEBPACK FOOTER //
// src/modules/stats/components/Z4.js